import { Theme } from '@mui/material/styles';
import '@mui/styles';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import { APP_FONT_WEIGHT_SEMIBOLD } from '@common/styles/fonts';

declare module '@mui/styles/defaultTheme' {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface, @typescript-eslint/no-empty-object-type
  interface DefaultTheme extends Theme {}
}

/**
 * Positioned to match CustomNotification's panel so the two header popovers read
 * as the same kind of surface.
 */
export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    trayContainer: {
      position: 'fixed',
      right: 15,
      top: 60,
      width: 420,
      maxHeight: 500,
      overflow: 'auto',
      zIndex: 1300,
      backgroundColor: theme.palette.primary.contrastText,
      boxShadow: '0 4px 8px 0 rgba(0,0,0,0.2)',
      borderRadius: 5,
    },
    trayHeader: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      height: 50,
      padding: theme.spacing(0, 1, 0, 2),
      borderBottom: `1px solid ${theme.palette.divider}`,
      backgroundColor: theme.palette.info.light,
    },
    trayTitle: {
      fontSize: '1rem',
      fontWeight: APP_FONT_WEIGHT_SEMIBOLD,
      color: theme.palette.info.dark,
    },
    /**
     * A thin summary strip, not a row: everything still waiting collapses into
     * one line rather than a queued row per file, which is what a batch of
     * fifteen would otherwise fill the panel with.
     */
    trayQueued: {
      padding: theme.spacing(0.75, 2),
      borderBottom: `1px solid ${theme.palette.divider}`,
      backgroundColor: theme.palette.action.hover,
      fontSize: '0.75rem',
      color: theme.palette.text.secondary,
    },
    trayList: {
      margin: 0,
      padding: 0,
      listStyle: 'none',
    },
    trayRow: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(1.5),
      padding: theme.spacing(1, 2),
      borderBottom: `1px solid ${theme.palette.divider}`,
    },
    rowText: {
      flex: 1,
      minWidth: 0,
    },
    rowName: {
      display: 'block',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      fontSize: '0.875rem',
    },
    rowDetail: {
      fontSize: '0.75rem',
      color: theme.palette.text.secondary,
    },
  })
);
